var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0309 16.5036C35.2846 34.1222 3.6935 41.2203 0.267961 16.5036C0.141089 -1.11497 31.6054 -8.2131 35.0309 16.5036Z",
    fill: "#664650"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1349 18.912C25.0081 18.405 25.5154 14.856 24.881 12.9547C24.1198 12.0674 22.7242 10.6731 21.0749 9.1521C18.1568 8.8986 14.224 8.77184 10.5446 9.1521C9.78338 12.9547 10.0373 19.9259 10.4179 23.475C15.239 24.1087 17.9032 24.1087 25.1349 23.475V21.9539V22.2074V18.912ZM17.6496 21.0668C17.3959 21.0668 16.6345 21.0669 16.0002 20.5599C15.3658 19.9262 14.8586 18.912 15.2392 17.898C15.4929 17.0107 16.3807 16.377 17.3957 16.377C18.2838 16.377 19.172 16.8839 19.4257 17.7711C19.8063 18.4049 19.9332 19.2921 19.4257 20.0526C18.9182 21.0666 17.7765 21.0668 17.6496 21.0668ZM19.9333 13.4617C19.1721 13.5884 16.2541 13.4617 12.0673 13.4617V10.9265C14.3511 10.7998 15.366 10.9265 19.6796 10.9265C19.8065 11.18 19.8063 11.0532 20.06 11.4335C19.9331 12.194 20.187 11.9406 19.9333 13.4617Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.c190b70a81c1f6c66624d31c54bac8a0.svg";
export { ForwardRef as ReactComponent };